import CopyCoordinates from "components/shared/copyCoordinates";
import TruncatedString from "components/shared/truncatedString";
import { formatExtendedProp } from "helpers/bid";
import { formatDateTimezone } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { bidPointTypes, bidPointTypesEnum } from "helpers/enums";
import { isFilledObj } from "helpers/form";
import { enumLabel } from "helpers/system";
import compact from "lodash/compact";
import React, { Component } from "react";

export default class TimelinePoint extends Component {
    state = {
        opened: false,
    };

    renderExtendedProperties = () => {
        const { extendedProperties } = this.props.point;
        const { extendedPropertiesConfig } = this.props;
        if (!isFilledObj(extendedProperties)) {
            return null;
        }
        return extendedPropertiesConfig.bidPoint.map((prop, index) => {
            const valueObj = extendedProperties.find((item) => item.propertyName === prop.propertyName);
            return (
                <div
                    key={prop.id}
                    className="b-timeline-point__city--full"
                    data-point-extended-props={index}
                    style={prop.order ? { order: prop.order } : {}}
                >
                    {prop.displayName}: {valueObj ? formatExtendedProp(valueObj.value, prop.typeCode) : ""}
                </div>
            );
        });
    };

    render() {
        const {
            geozone: { city, village, county, address, location },
            type,
            planEnterDateOffset,
            secondaryPlanEnterDateOffset,
            planLeaveDateOffset,
            secondaryPlanLeaveDateOffset,
            customPointType,
            client,
            contactPerson,
            counterparty,
            extendedProperties,
            loadOptions,
            comment,
            externalCity,
        } = this.props.point;
        const { letter, loadUnloadType } = this.props;
        const typeTitle =
            type === bidPointTypesEnum.CustomPoint ? customPointType.name : enumLabel(bidPointTypes, type);
        const utcTimezone = formatDateTimezone({ planEnterDateOffset });
        return (
            <div className="b-timeline-point">
                <div className="b-timeline-point__figure">
                    <div className="b-timeline-point__circle">
                        <div className="b-timeline-point__circle--text">{letter}</div>
                    </div>
                    <div className="b-timeline-point__line" />
                </div>
                <div className="b-timeline-point__data">
                    <div className="b-timeline-point__city">
                        <div className="pb-1 b-timeline-point__city--info">
                            <div>
                                {(client ||
                                    contactPerson?.name ||
                                    contactPerson?.phoneNumber ||
                                    counterparty?.name ||
                                    (extendedProperties && extendedProperties.length > 0) ||
                                    (loadOptions && loadOptions.length > 0)) && (
                                    <span
                                        className="b-timeline-point__more-link"
                                        onClick={() => this.setState({ opened: !this.state.opened })}
                                    >
                                        {this.state.opened ? (
                                            <i className="icon-uEA72-chevron-down" />
                                        ) : (
                                            <i className="icon-uEA72-chevron-down rotated" />
                                        )}
                                    </span>
                                )}
                                <span
                                    className="b-timeline-point__city--name"
                                    onClick={() =>
                                        this.props.mergeMapViewport({
                                            center: [...location.coordinates].reverse(),
                                            zoom: 12,
                                        })
                                    }
                                >
                                    {city || village || county}
                                </span>
                                <small className="b-timeline-point__city--timezone">&nbsp;{utcTimezone}</small>
                            </div>
                            <div className="b-timeline-point__city--type-wrap c-dropd">
                                <small className="b-timeline-point__city--type">{typeTitle}</small>
                            </div>
                        </div>
                        <div className="b-timeline-point__city--full" data-test-id="point-address">
                            <CopyCoordinates coordinates={[...location.coordinates].reverse().join(", ")} />
                            {address}
                        </div>
                        {comment && (
                            <div className="b-timeline-point__city--full" data-test-id="point-comment">
                                Комментарий: <TruncatedString text={comment} />
                            </div>
                        )}
                        {externalCity && (
                            <div className="b-timeline-point__city--full" data-test-id="point-external-city">
                                Город для 1С: {externalCity}
                            </div>
                        )}
                        {this.state.opened && (
                            <>
                                {client && (
                                    <div
                                        className="b-timeline-point__city--full"
                                        data-test-id="point-client"
                                    >{`Клиент: ${client}`}</div>
                                )}
                                {(contactPerson?.name || contactPerson?.phoneNumber) && (
                                    <div className="b-timeline-point__city--full" data-test-id="point-contact-person">
                                        {`Контактное лицо: ${compact([contactPerson.name, contactPerson.phoneNumber]).join(", ")}`}
                                    </div>
                                )}
                                {counterparty?.name && (
                                    <div className="b-timeline-point__city--full" data-test-id="point-counterparty">
                                        {`${type === bidPointTypesEnum.LoadPoint ? "Грузоотправитель" : "Грузополучатель"}: ${counterparty.name}`}
                                    </div>
                                )}
                                {loadOptions && loadOptions.length > 0 && (
                                    <div className="b-timeline-point__city--full" data-test-id="point-load-options">
                                        {`${type === bidPointTypesEnum.LoadPoint ? "Типы погрузки" : "Типы разгрузки"}: ${loadOptions
                                            .map((option) => enumLabel(loadUnloadType, option.id))
                                            .join(", ")}`}
                                    </div>
                                )}
                                <div className="d-flex flex-column">{this.renderExtendedProperties()}</div>
                            </>
                        )}
                    </div>
                    <div className="b-timeline-point__info">
                        <div className="b-timeline-point__table">
                            <div className="b-timeline-point__date--name">Плановый въезд</div>
                            <div className="b-timeline-point__date--value" data-test-id="point-plan-enter-date">
                                {dateTimeToView(planEnterDateOffset, "DD.MM.YY HH:mm")}
                                {secondaryPlanEnterDateOffset && (
                                    <>
                                        &nbsp;-&nbsp;
                                        {dateTimeToView(secondaryPlanEnterDateOffset, "DD.MM.YY HH:mm")}
                                    </>
                                )}
                            </div>
                            <div className="b-timeline-point__date--value" />
                            {planLeaveDateOffset && (
                                <>
                                    <div className="b-timeline-point__date--name">Плановый выезд</div>
                                    <div className="b-timeline-point__date--value" data-test-id="point-plan-leave-date">
                                        {dateTimeToView(planLeaveDateOffset, "DD.MM.YY HH:mm")}
                                        {secondaryPlanLeaveDateOffset && (
                                            <>
                                                &nbsp;-&nbsp;
                                                {dateTimeToView(secondaryPlanLeaveDateOffset, "DD.MM.YY HH:mm")}
                                            </>
                                        )}
                                    </div>
                                    <div className="b-timeline-point__date--value" />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
